import $ from 'jquery'

class Article {
    constructor() {
        this.sendComment()
    }

    sendComment() {
        $('#cmt_content').on('input', function () {
            let restCharacter = 500 - parseInt(this.value.length)
            $('#cmt_count').text(restCharacter)
            $('.input-comment .left').removeClass('d-none')
            if (this.value.length >= 5) {
                $('#cmt_popup').removeAttr('disabled')
                $('.input-comment .left').addClass('d-none')
                $('#cmt_popup').on('click', function () {
                    $('.comment-box-popup').css('display', 'block')
                })
            } else if (this.value.length === 0) {
                $('.input-comment .left').addClass('d-none')
            } else {
                $('#cmt_popup').attr('disabled', 'disabled')
            }

            [$('.popup-background'), $('.popup-close')].forEach(function (element) {
                element.on('click', function () {
                    $('.comment-box-popup').css('display', 'none')

                });
            });
        });
        // $('#cmt_content').on('blur', function () {
        //     $('.input-comment .left').addClass('d-none')
        // })
    }
}

export default $(function () {
    new Article
})
